//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import _ from 'underscore';

import { CollectionsAction } from '@collections/redux/collectionsActions';
import { COLLECTIONS_ACTIONS, ICollectionsState } from '@collections/redux/collectionsModel';

const initialState: ICollectionsState = {
  collections: undefined,
  creatingCollection: false,
  createdCollection: undefined,
  collectionAddsPending: [],
  collectionAddErrors: [],
  requestingCollections: false,
};

export default function CollectionsReducer(
  state: ICollectionsState = initialState,
  action: CollectionsAction,
): ICollectionsState {
  switch (action.type) {
    case COLLECTIONS_ACTIONS.RECEIVE_COLLECTIONS: {
      return {
        ...state,
        collections: action.collections,
        requestingCollections: false,
      };
    }
    case COLLECTIONS_ACTIONS.REQUEST_CREATE_COLLECTION: {
      return {
        ...state,
        creatingCollection: true,
      };
    }
    case COLLECTIONS_ACTIONS.CLEAR_CREATED_COLLECTION: {
      return {
        ...state,
        createdCollection: undefined,
      };
    }
    case COLLECTIONS_ACTIONS.RECEIVE_CREATE_COLLECTION: {
      return {
        ...state,
        createdCollection: action.collection,
        creatingCollection: false,
      };
    }
    case COLLECTIONS_ACTIONS.REQUEST_ADD_SOURCE_TO_COLLECTION: {
      state.collectionAddsPending.push(action.request);
      return {
        ...state,
      };
    }
    case COLLECTIONS_ACTIONS.RECEIVE_ADDED_SOURCE_TO_COLLECTION: {
      return {
        ...state,
        collectionAddsPending: state.collectionAddsPending.filter((a) => !_(a).isEqual(action.request)),
      };
    }
    case COLLECTIONS_ACTIONS.RECEIVE_ADD_SOURCE_TO_COLLECTION_ERROR: {
      state.collectionAddErrors.push({
        errorMessage: action.error,
        addRequest: action.request,
      });
      return {
        ...state,
      };
    }

    case COLLECTIONS_ACTIONS.REQUEST_COLLECTIONS: {
      return {
        ...state,
        requestingCollections: true,
      };
    }
    default:
      return state;
  }
}
